import { forwardRef, memo } from 'react';

interface ModalTextInputProps {
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  placeholder?: string;
}

export const ModalTextInput = memo(
  forwardRef<HTMLInputElement, ModalTextInputProps>(function ModalTextInput(props, ref) {
    return (
      <input
        ref={ref}
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        onKeyDown={props.onKeyDown}
        className="mt-4 h-10 w-full rounded-lg border border-white/[0.08] bg-white/[0.04] px-3 text-[14px] text-zinc-100 placeholder-zinc-600 focus:border-white/[0.16] focus:outline-none"
        placeholder={props.placeholder}
      />
    );
  }),
);
